import { render, staticRenderFns } from "./SelectRank.vue?vue&type=template&id=478e940c&scoped=true&"
import script from "./SelectRank.vue?vue&type=script&lang=js&"
export * from "./SelectRank.vue?vue&type=script&lang=js&"
import style0 from "./SelectRank.vue?vue&type=style&index=0&id=478e940c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478e940c",
  null
  
)

export default component.exports